import { HistoryItem, HistoryOperationItem } from '../components/partners/components/useHistoryItemRenderer'
import { apiCall } from '../utils/api'

export type GetHistoryRequest = {
   memberId: string
   page?: number
   size?: number
}
export type GetHistoryOperationRequest = {
   memberId: string
   operationId: string
   page?: number
   size?: number
}
export async function getHistory(
   request: GetHistoryRequest,
): Promise<{ items: Array<HistoryItem>; totalSize: number }> {
   const result = await apiCall({
      url: `${process.env.REACT_APP_PUBLIC_STAGE_API}/loyalty/v2/members/${request.memberId}/history`,
      method: 'GET',
   })

   return { items: result.data, totalSize: parseInt(result.headers['x-total-count']) }
}

export async function getOperationHistory(
   request: GetHistoryOperationRequest,
): Promise<{ items: Array<HistoryOperationItem>; totalSize: number }> {
   const result = await apiCall({
      url: `${process.env.REACT_APP_PUBLIC_STAGE_API}/loyalty/v2/members/${request.memberId}/history?operationId=${request.operationId}`,
      method: 'GET',
   })

   return { items: result.data, totalSize: parseInt(result.headers['x-total-count']) }
}